export default __webpack_public_path__ + "static/media/basketball-icon.a26c03b3.png";